import { render, staticRenderFns } from "./NotifikacijaBase.vue?vue&type=template&id=43b6f3ff&scoped=true&"
import script from "./NotifikacijaBase.vue?vue&type=script&lang=js&"
export * from "./NotifikacijaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6f3ff",
  null
  
)

export default component.exports